import React, { useState, useEffect } from "react"; // Added useEffect import
import { Typography, Grid, Box } from "@mui/material";
import Button from "../../components/Button";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import HeaderFooterHoc from "../../HOC/HeaderFooterHOC";
import "./styles.css";
import Badge from "@mui/material/Badge";
import { Line } from "react-chartjs-2";
import { useOnClickOutside } from './hooks';
import { items } from './CarouselData';
import Carousel from "react-material-ui-carousel";
import { Paper } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  LineElement,
  Legend,
  PointElement,
  Filler,
} from "chart.js";



ChartJS.register(
  Title,
  Tooltip,
  LineElement,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler
);

const JobCard = ({ title, count, color, onClick }) => (
  <Grid item>
    <div className="Job" onClick={onClick} style={{ position: "relative" }}>
      <Typography sx={{ fontSize: "15px", fontWeight: "bold", color: "#333" }}>
        {title}
      </Typography>
      <div
        className="joblist"
        id={`box-${color}`}
        style={{
          padding: "20px",
          borderRadius: "8px",
          backgroundColor: "#fff",
          border: `2px solid ${color}`,
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          position: "relative",
        }}
      >
        <Badge
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
            zIndex: 1,
          }}
          badgeContent={count || 0}
          color={color}
        />
        <Typography variant="body1" sx={{ color: "#333" }}>
          {count || 0}
        </Typography>
      </div>
    </div>
  </Grid>
);

function Plumber() {
  const navigate = useNavigate();
  const [jobCounts, setJobCounts] = useState({
    PAID: 0,
    COMPLETED: 0,
    IN_PROGRESS: 0,
    CANCELLED: 0,
    PAUSED: 0,
    UNPAID: 0,
    CREATED: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJobCounts = async () => {
      try {
        const token = localStorage.getItem("authToken"); // Retrieve token from localStorage (or other storage mechanism)

        const response = await fetch('https://jobmanagement-497524552274.us-central1.run.app/api/jobs/status-count', {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch job counts');
        }

        const data = await response.json();
        setJobCounts(data);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching job counts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchJobCounts();
  }, []);

  const jobCards = [
    { title: 'New Jobs', status: 'CREATED', color: 'orange', path: '/allMatchingJobs' },
    { title: 'In Progress Jobs', status: 'IN_PROGRESS', color: 'primary', path: '/InProgressJobs' },
    { title: 'Completed Jobs', status: 'COMPLETED', color: 'success', path: '/CompletedJobs' },
    { title: 'Cancelled and Rescheduled Jobs', status: 'CANCELLED', color: 'error', path: '/CancelledAndRescheduledJobs' },
    { title: 'Paused Jobs', status: 'PAUSED', color: 'warning', path: '/PausedJobs' },
    { title: 'Paid Jobs', status: 'PAID', color: 'secondary', path: '/PaidJobs' },
    { title: 'Unpaid Jobs', status: 'UNPAID', color: 'default', path: '/allMatchingJobs' },
    { title: 'Quotations Jobs', status: 'QUOTATIONS', color: 'error', path: '/TopQuotes' },
  ];

  if (loading) {
    return <Typography>Loading job statistics...</Typography>;
  }

  if (error) {
    return <Typography color="error">Error loading job counts: {error}</Typography>;
  }

  return (
    <Grid sx={{ background: "#F4F4F4", paddingBottom: "30px" }}>
      <Grid
        container
        sx={{
          padding: "5%",
          backgroundColor: "white",
          border: "1px solid #EAEAEA",
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "20px",
          margin: 0,
          width: "100%",
        }}
      >
        {jobCards.map((card) => (
          <JobCard
            key={card.status}
            title={card.title}
            count={jobCounts[card.status]}
            color={card.color}
            onClick={() => navigate(card.path, { state: card.status })}
          />
        ))}
      </Grid>

      <Grid
        className="viewJobs-box"
        onClick={() => navigate("/allMatchingJobs", { state: "All Matching jobs" })}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "15px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          border: "1px solid #EAEAEA",
          cursor: "pointer",
          marginTop: "20px",
        }}
      >
        <Typography sx={{ fontWeight: "bold", color: "#333" }}>
          View all matching Jobs
        </Typography>
        <Badge badgeContent={Object.values(jobCounts).reduce((a, b) => a + b, 0)} color="primary" />
        <ArrowForwardIosIcon sx={{ color: "#1976d2" }} />
      </Grid>

      {/* Rest of your component remains the same */}
    </Grid>
  );
}

export default HeaderFooterHoc(Plumber, {
  bodyClassname: "",
});
